module.exports = __webpack_public_path__ + "static/04-5d70c35e6872456d2f15abd7c891fd2f.jpg";